/* global SendAdobeData */
import { getUiLibraryClasses, showPageLoader } from '../utils';
import { logError, logException } from '../services/sentryService';

export const initCustomPaypalButton = () => {
  const $makeThePaypalOrderBtn = $('#makeThePaypalOrder');
  const $paypalErrorMessage = $('#js-paypalErrorMessage');
  const $placeOrderForm = $('#js-placeOrderForm');

  let isPlaceOrderFormSubmitted = false;

  // Expose callback functions in the global window object for mobile apps: onPaypalApprove, onPaypalCancel, onPaypalError
  window.onPaypalApprove = (paypalOrderId) => {
    showPageLoader();
    // Assign paypal order id
    $('#js-paypalOrderId').val(paypalOrderId);

    // Try to prevent placing of another order if `onApprove` handler is called by Paypal SDK more than once for some reason
    if (!isPlaceOrderFormSubmitted) {
      isPlaceOrderFormSubmitted = true;
      $placeOrderForm.submit();
    } else {
      try {
        let cartEl = document.getElementById('cartDataObject').innerText;
        let cartDataObject = null;
        cartDataObject = cartEl !== '' ? JSON.parse(cartEl) : null;
        const customer = cartDataObject?.customer;

        logError(
          `Mobile App Paypal order placed more than once for customer ${customer?.customerId}`
        );
      } catch (e) {
        logException(e, { area: 'checkout', payment: 'Mobile App Paypal' });
      }
    }
  };

  window.onPaypalCancel = () => {
    enableCustomPaypalButton();
  };

  window.onPaypalError = (error) => {
    $paypalErrorMessage.removeClass('hide');
    enableCustomPaypalButton();
    logError(`Pay with Paypal from Mobile App error: ${error}`);
  };

  $makeThePaypalOrderBtn.on('dblclick', (e) => {
    e.preventDefault();
  });

  $makeThePaypalOrderBtn.click(async (e) => {
    e.preventDefault();
    $makeThePaypalOrderBtn.attr('disabled', true);
    $paypalErrorMessage.addClass('hide');

    try {
      SendAdobeData(
        'customClickTrack',
        'Checkout',
        'Paypal Preview Button',
        'Buy Now'
      );

      const paypalOrderAmount = $('#js-paypalOrderAmount').val();
      const response = await fetch(
        `/checkout/paypal-order?previewPageAmount=${paypalOrderAmount}`,
        { method: 'GET' }
      );
      if ((await response.status) == 409) {
        //'conflict' means the page is stale -- cart has been modified
        //refresh + print cart changed
        location.href = '/checkout/preview?paypalConsistencyCheck=true';
        showPageLoader();
      } else {
        const jsonResponse = await response.json();
        window.zooplusApp.initiateMobileAppPaypal(jsonResponse.paypalOrderId);
      }
    } catch (error) {
      logError(`Error on click of the custom Paypal button: ${error}`);
      // Handle the error or display an appropriate error message to the user
      $paypalErrorMessage.removeClass('hide');
      enableCustomPaypalButton();
    }
  });

  const enableCustomPaypalButton = () => {
    $makeThePaypalOrderBtn.removeClass(
      ...getUiLibraryClasses(['btn--loading'])
    );
    $makeThePaypalOrderBtn.removeAttr('disabled');
  };
};
